import React from 'react';
import styles from './Dropdown.module.scss';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';

import { DropdownProps } from './types';

export const Dropdown: React.FC<DropdownProps> = ( {
	isShown,
	onClose,
	anchorEl,
	children,
	...props
} ) => {
	return (
		<Popper
			anchorEl={ anchorEl }
			placement={ 'bottom-start' }
			{ ...props }
			open={ isShown }
		>
			<ClickAwayListener onClickAway={ ( event ) => onClose?.( event ) }>
				<Paper className={ styles[ 'dropdown' ] }>{ children }</Paper>
			</ClickAwayListener>
		</Popper>
	);
};
